export default {
  organization: {},
  organizations: [],
};
